import { timestampDate } from '@bufbuild/protobuf/wkt'
import type { Timestamp } from '@bufbuild/protobuf/wkt'

/**
 * JST は固定 +9h (DST なし)。実行環境のタイムゾーンに依存させない
 * (weather-icon-unify-48koma 設計書 §8、旧 weatherIconStrip.ts の踏襲)。
 */
const JST_OFFSET_MS = 9 * 60 * 60 * 1000

/** proto Timestamp を JST の時 (0-23) に写す。 */
export function jstHour(ts: Timestamp): number {
  return new Date(timestampDate(ts).getTime() + JST_OFFSET_MS).getUTCHours()
}

/**
 * 昼夜判定 (spec `jma-weather-data.md` §5 / weather-icon-unify-48koma 設計書 grill Q4):
 * JST `6:00 ≤ t < 18:00` を昼とする (06:00 は昼、18:00 は夜)。
 */
export function isDaytimeHour(hour: number): boolean {
  return hour >= 6 && hour < 18
}
